import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CATEGORIES } from "@/lib/data";

export default function Produtos() {
  return (
    <div data-testid="produtos-page">
      {/* Page header */}
      <section className="relative bg-[#0a0a0a] text-white overflow-hidden">
        <div className="grain absolute inset-0" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-32">
          <div className="overline mb-4">Catálogo · 08 Categorias</div>
          <h1 className="font-display font-black uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight max-w-4xl">
            Produtos para cada <span className="text-[#1FA8E0]">aplicação</span> industrial.
          </h1>
          <p className="mt-6 text-white/70 max-w-2xl text-lg">
            Gama completa de sistemas de fixação, ferramentas, químicos, EPI e acessórios industriais.
          </p>
        </div>
      </section>

      {/* Categories stacked */}
      <section className="bg-white">
        {CATEGORIES.map((c, idx) => {
          const reversed = idx % 2 === 1;
          return (
            <div
              key={c.slug}
              data-testid={`product-section-${c.slug}`}
              className={`border-b border-[#e4e4e7] ${idx % 2 === 0 ? "bg-white" : "bg-[#f5f5f5]"}`}
            >
              <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28 grid grid-cols-12 gap-8 md:gap-14 items-center">
                <div className={`col-span-12 md:col-span-6 ${reversed ? "md:order-2" : ""}`}>
                  <div className="relative overflow-hidden bg-[#111] aspect-[4/3]">
                    <img
                      src={c.image}
                      alt={c.title}
                      loading="lazy"
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 left-4 bg-[#1FA8E0] text-[#0a1e2e] font-mono-cet text-xs tracking-widest px-3 py-1">
                      CAT — {c.code}
                    </div>
                  </div>
                </div>
                <div className={`col-span-12 md:col-span-6 ${reversed ? "md:order-1" : ""}`}>
                  <div className="overline mb-3">Categoria {c.code}</div>
                  <h2 className="font-display font-bold uppercase text-4xl md:text-5xl text-[#0d4c7d] leading-[0.95] tracking-tight">
                    {c.title}
                  </h2>
                  <div className="mt-2 font-mono-cet text-sm text-[#555] uppercase tracking-wider">
                    {c.short}
                  </div>
                  <p className="mt-6 text-lg text-[#333] leading-relaxed">{c.description}</p>
                  <Link
                    to="/contactos"
                    data-testid={`product-cta-${c.slug}`}
                    className="btn-cet btn-dark mt-8"
                  >
                    Pedir Informação <ArrowUpRight size={18} />
                  </Link>
                </div>
              </div>
            </div>
          );
        })}
      </section>

      <section className="bg-[#0d4c7d] text-white">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 flex flex-col md:flex-row items-center justify-between gap-6">
          <h3 className="font-display font-bold uppercase text-3xl md:text-4xl">
            Não encontra o que procura?
          </h3>
          <Link to="/contactos" data-testid="produtos-bottom-cta" className="btn-cet btn-primary">
            Fale Connosco <ArrowUpRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
